exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".news {\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    text-align: center;\n    padding-top: 1%;\n}\n\n.news h2 {\n    text-decoration: underline;\n}\n\n.news hr {\n    width: 60%;\n    border-bottom: 1px solid black;\n}", ""]);

// exports
